<template>
    <el-drawer :visible.sync="modals" title="切换二维码" :size="isMobile ? '100%' : 400" >
		<div v-if="list.length > 0">
			<el-button v-if="$store.state.cfg.configs.system.sale_update_wechat == 1" type="primary" @click="add" class="mb14">添加我的二维码</el-button>
			<div v-for="item in list" class="list mb14">
				<el-card >
				  
				  
				  <div slot="header" class="clearfix">
				      <!-- <span>卡片名称</span>
				      <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
					  
					  <div class="acea-row row-between-wrapper">
						  <el-image :src="item.qrcode" class="qrcode" fit="cover" :preview-src-list="[item.qrcode]" lazy></el-image>
						  <div class="flex1">
							  <div class=" ">
								  <h4 class="title line1">{{item.nickname}}</h4>
								  <div class="message">
								  		{{item.account}}
								  </div>
							  </div>
						  </div>
						  
						  <div>
							<span class="current" v-if="item.is_use == 1">使用中</span>
							<el-button  type="primary" @click="selectWechat(item)" size="small" v-else>使用</el-button>
						  </div>
					  </div>
				  </div>
				  
				  <div class="acea-row row-right item" v-if="$store.state.cfg.configs.system.sale_update_wechat == 1">
					  <a @click="edit(item)">修改</a>
				  </div>
				  
				</el-card>
				<!-- <div class="useing" v-if="item.is_use == 1">使用中</div> -->
			</div>
			
		</div>
		<div v-else class="acea-row row-middle row-center">
			<div>
				<el-empty description="还未分配二维码" class="mt25 mb20">
					<el-button v-if="$store.state.cfg.configs.system.sale_update_wechat == 1" type="primary" @click="add">添加我的二维码</el-button>
				</el-empty>
			</div>
		</div>
		
		<create-from
		  @getList="getList"
		  ref="createFrom"
		></create-from>
    </el-drawer>
	
</template>

<script>
import { mapState } from 'vuex';
import {loginAdminWechats,swithUseApi } from '@/api/setting/wechat';
import createFrom from '@/pages/auth/wechat/components/createFrom';
export default {
  name: 'adminSelectWechat',
  components: { createFrom },
  computed: {
    ...mapState('media', ['isMobile']),
  },
  props:{
  	currentCode:''
  },
  data() {
    return {
	  modals:false,
      spinShow: false,
	  list:[],
    };
  },
  created() {},
  methods: {
    
	selectWechat(wechat)
	{
		this.spinShow = true;
		swithUseApi(wechat.id)
		  .then(async (res) => {
		    this.$message.success(res.msg);
			this.spinShow = false;
			this.getList(true)
		  })
		  .catch((res) => {
			this.spinShow = false;
		    this.$message.error(res.msg);
		  });
	},
    
    init() {
	  this.getList()
    },
	
	getList(isStore = false) {
	  this.spinShow = true;
	  let that = this;
	  loginAdminWechats()
	    .then(async (res) => {
	      this.list = res.data;
		  this.$store.commit('login/wechats', this.list);
		  if(isStore){
			this.$emit('change');
		  }
	      this.spinShow = false;
	    })
	    .catch((res) => {
	      this.spinShow = false;
	      this.$message.error(res.msg);
	    });
	},
	// 编辑
	edit(row, index) {
	  this.$refs.createFrom.modals = true;
	  this.$refs.createFrom.init(row.id)
	},
	
	add() {
	  this.$refs.createFrom.modals = true;
	  this.$refs.createFrom.formValidate.admin_id = this.$store.state.login.adminInfo.id;
	  this.$refs.createFrom.init()
	},
  },
};
</script>

<style lang="scss" scoped>

::v-deep .el-drawer__body{
	padding: 20px 20px;
	
}

::v-deep .el-card__body, .el-main {
  padding: 0;
  position: relative;
}

.list{
	position: relative;
	.item{
		padding: 10px;
		font-size: 12px;
	}
	.qrcode{
		width:60px;
		height:60px;
		margin-right: 10px;
	}
	.useing{
		position: absolute;
		right: -10px;
		top: -9px;
		background-color: var(--prev-color-primary-light-9);
		color: #fff;
		font-size: 12px;
		padding: 4px 8px;
		border-radius: 4px;
	}
}

.message{
	margin-top:18px;
	font-size:12px;
}

.current{
	font-size:12px;
	color: #f56c6c;
}

</style>
